import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";

import { Navigate } from "react-router-dom";

import { showErrors } from "../../utils/Helpers";
import Alert from "../../utils/Alert";

import InvoiceDetail from "../../components/invoices/InvoiceDetail";
import InputBox from "../../components/invoices/InputBox";
import Boxes from "../../components/invoices/Boxes";
import Spinner from "../../components/generics/Spinner";
import Modal from "../../components/generics/Modal";
import { INVOICE_PRICE_DEVIATION } from "../../constants/constants";

import {
  fetchBrands,
  fetchBrandsSuccess,
  fetchBrandsFailure,
  fetchGrades,
  fetchGradesSuccess,
  fetchGradesFailure,
} from "../../store/inventories/actions";
import {
  fetchBoxes,
  fetchBoxesSuccess,
  fetchBoxesFailure,
  fetchInvoice,
  fetchInvoiceSuccess,
  fetchInvoiceFailure,
} from "../../store/invoices/actions";
import { fetchStations, fetchStationsSuccess, fetchStationsFailure } from "../../store/sessions/actions";

import { createInventories, getItems } from "../../store/inventories/api";
import _ from "lodash";
import { withRouter } from "utils/WithRouter";

export class InvoiceContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentBox: {
        index: -1,
        station_index: -1,
        station: undefined,
        plant: "",
        vendor_lot_number: "",
        price: "",
        packingDate: "",
        brand_index: -1,
        brand: undefined,
        grade_index: -1,
        grade: undefined,
        category_index: -1,
        category: undefined,
        item_index: -1,
        item: undefined,
        selectedItem: null,
        item_average_invoice_price: 0,
        weight: "",
        numberItems: "",
        has_grade: false,
        measureUnit: undefined,
      },
      boxes: [],
      numberBoxes: 1,
      isLoadingItems: false,
      itemsList: [],
      isAlreadyFinished: false,
      errors: [],
      errors_box: [],
      over_average_price: false,
      openFinishInvoiceModal: false,
      finishing: false,
    };
    this.alertRef = React.createRef();
    this.debounceFinish = _.debounce(this.finishInvoice, 1000);
    this.debounceFinishInvoiceWithPricesCheck = _.debounce(this.finishInvoiceWithPricesCheck, 400);
  }

  componentDidMount() {
    this.props.fetchInvoice(this.props.match.params.id);
    this.props.fetchBoxes(this.props.match.params.id);
    this.props.fetchStations();
    this.props.fetchBrands();
    this.props.fetchGrades();
  }

  componentDidUpdate(prevProps) {
    // if this happens, it means the invoice already has boxes
    if (prevProps.boxesList.boxes.length < this.props.boxesList.boxes.length) {
      const newState = {
        currentBox: {
          index: -1,
          station_index: -1,
          station: undefined,
          plant: undefined,
          vendor_lot_number: undefined,
          price: undefined,
          packingDate: undefined,
          brand_index: -1,
          brand: undefined,
          grade_index: -1,
          grade: undefined,
          category_index: -1,
          category: undefined,
          item_index: -1,
          item: undefined,
          selectedItem: null,
          item_average_invoice_price: 0,
          weight: undefined,
          numberItems: undefined,
          has_grade: false,
          measureUnit: undefined,
        },
        numberBoxes: 1,
        isLoadingItems: false,
        itemsList: [],
        isAlreadyFinished: true,
        hasBoxes: this.props.invoiceDetail.invoice.has_boxes,
        boxes: this.props.boxesList.boxes.map((box) => {
          const has_grade = box.extra_info ? (box.extra_info.grade ? true : false) : false;
          return {
            id: box.id,
            item_id: box.item.id,
            item: box.item.name,
            item_average_invoice_price: box.item_average_invoice_price,
            category: box.category.category_name,
            brand: box.brand.brand_name,
            brand_id: box.brand.id,
            station: box.station.name,
            station_id: box.station.id,
            plant: box.plant,
            vendor_lot_number: box.vendor_lot_number,
            weight: box.weight,
            pieces: box.number_items,
            price: box.price,
            packingDate: box.packing_date,
            has_grade: has_grade ? true : false,
            grade: has_grade ? box.extra_info.grade.grade : undefined,
            grade_id: has_grade ? box.extra_info.grade.id : undefined,
            measure_unit: box.item.measure_unit,
          };
        }),
      };
      this.setState(newState);
    }
    if (prevProps.invoiceDetail.loading && !this.props.invoiceDetail.loading) {
      this.setState({
        hasBoxes: this.props.invoiceDetail.invoice.has_boxes,
      });
    }
  }

  spliceError = (element) => {
    var errors = this.state.errors.slice();
    var index = errors.indexOf(element);
    if (index !== -1) {
      errors.splice(index, 1);
    }
    return errors;
  };

  spliceError_box = (element) => {
    var errors = this.state.errors_box.slice();
    var index = errors.indexOf(element);
    if (index !== -1) {
      errors.splice(index, 1);
    }
    return errors;
  };

  handleStationChange = (event) => {
    let currentBox = this.state.currentBox;
    currentBox.station = this.props.stationsList.stations.results[event.target.value];
    currentBox.station_index = parseInt(event.target.value, 10);
    if (currentBox.station_index !== 1) {
      currentBox.plant = "";
    }
    var errors = this.spliceError("station");
    this.setState({ currentBox, errors });
  };

  handlePriceChange = (event, index) => {
    let currentBox = this.state.currentBox;
    currentBox.price = event.target.value;
    var errors = this.spliceError("price");
    this.setState({ currentBox, errors });
  };

  handleDatePackingChange = (event) => {
    let currentBox = this.state.currentBox;
    currentBox.packingDate = event.target.value;
    var errors = this.spliceError("packingDate");
    this.setState({ currentBox, errors });
  };

  handleBrandChange = (event) => {
    let currentBox = this.state.currentBox;
    currentBox.brand = this.props.brandsList.brands.results[event.target.value];
    currentBox.brand_index = event.target.value;
    var errors = this.spliceError("brand");
    this.setState({ currentBox, errors });
  };

  handleGradeChange = (event) => {
    let currentBox = this.state.currentBox;
    currentBox.grade = this.props.gradesList.grades.results[event.target.value];
    currentBox.grade_index = event.target.value;
    var errors = this.spliceError("grade");
    this.setState({ currentBox, errors });
  };

  onFinishLoading = () => {
    this.setState({ isLoadingItems: false });
  };

  searchItems = (input, callback) => {
    this.setState({ isLoadingItems: true });
    let options = [];
    getItems(input, null, null, null, null, true)
      .then((r) => {
        this.setState({ itemsList: r.data }, this.onFinishLoading);
        r.data.results.map((item) => {
          options.push({ value: item.id, label: item.name });
        });
        callback(options);
      })
      .catch((err) => {
        this.setState({ isLoadingItems: false });
        console.log(err);
      });
  };

  handleItemChange = (event) => {
    let currentBox = this.state.currentBox;
    if (event === null || event.value === undefined) {
      currentBox.grade_index = -1;
      currentBox.grade = undefined;
      currentBox.item = undefined;
      currentBox.has_grade = false;
      currentBox.item_index = -1;
      currentBox.selectedItem = null;
      currentBox.station_index = -1;
      currentBox.station = undefined;
      currentBox.plant = "";
      currentBox.vendor_lot_number = "";
      currentBox.numberItems = "";
      currentBox.item_average_invoice_price = 0;
      this.setState({ currentBox });
    } else {
      let item_index = this.arrayObjectIndexOf(this.state.itemsList.results, event.value, "id");
      let item = this.state.itemsList.results[item_index];
      currentBox.measureUnit = item.measure_unit;
      if (item.station) {
        currentBox.station_index = item.station.id;
        currentBox.station = this.props.stationsList.stations.results[item.station.id];
      }
      currentBox.numberItems = item.master_packing_number ? item.master_packing_number : "";
      if (!item.has_grade) {
        currentBox.grade_index = -1;
        currentBox.grade = undefined;
      }
      currentBox.item = item;
      currentBox.selectedItem = event;
      currentBox.plant = "";
      currentBox.vendor_lot_number = undefined;
      currentBox.item_average_invoice_price = item.average_invoice_price;
      currentBox.has_grade = item.has_grade;
      currentBox.item_index = item.id;
      var errors = this.spliceError("item");
      this.setState({ currentBox, errors });
    }
  };

  handleWeightChange = (event, index) => {
    let currentBox = this.state.currentBox;
    currentBox.weight = event.target.value;
    var errors = this.spliceError("weight");
    this.setState({ currentBox, errors });
  };

  handleNumberItemsChange = (event, index) => {
    let currentBox = this.state.currentBox;
    currentBox.numberItems = event.target.value;
    var errors = this.state.errors.slice();
    var index_error = errors.indexOf("numberItems");
    //check if the number of items is an integer and positive value
    if (currentBox.numberItems % 1 > 0) {
      if (index_error === -1) {
        errors.push("numberItems");
      }
    } else {
      if (!(index_error === -1)) {
        errors = this.spliceError("numberItems");
      }
    }
    this.setState({ currentBox, errors });
  };

  handlePlantChange = (event, index) => {
    let currentBox = this.state.currentBox;
    currentBox.plant = event.target.value;
    var errors = this.state.errors.slice();
    var index_error = errors.indexOf("plant");
    if (currentBox.plant === "") {
      if (index_error === -1) {
        errors.push("plant");
      }
    } else {
      if (!(index_error === -1)) {
        errors = this.spliceError("plant");
      }
    }
    this.setState({ currentBox, errors });
  };

  handleLotChange = (event) => {
    let currentBox = this.state.currentBox;
    currentBox.vendor_lot_number = event.target.value;
    var errors = this.state.errors.slice();
    var index_error = errors.indexOf("vendor_lot_number");
    if (currentBox.vendor_lot_number === "") {
      if (index_error === -1) {
        errors.push("vendor_lot_number");
      }
    } else {
      if (!(index_error === -1)) {
        errors = this.spliceError("vendor_lot_number");
      }
    }
    this.setState({ currentBox, errors });
  };

  submitBox = () => {
    let multiple = this.state.numberBoxes > 1;
    this.setState({ submitting: true });
    let box = this.state.currentBox;
    const weightShouldBeLimited = this.weightShouldBeLimited();
    if (
      this.state.errors_box.length === 0 &&
      box.numberItems > 0 &&
      box.station_index !== -1 &&
      box.brand_index !== -1 &&
      box.item_index !== -1 &&
      box.packingDate !== undefined &&
      box.packingDate !== "" &&
      box.price !== undefined &&
      box.price !== "" &&
      box.price > 0 &&
      (!box.measureUnit || !weightShouldBeLimited || box.weight <= 99) &&
      box.weight > 0 &&
      moment().format("YYYY-MM-DD") >= moment(box.packingDate).format("YYYY-MM-DD") &&
      box.vendor_lot_number !== undefined &&
      box.vendor_lot_number !== ""
    ) {
      if (box.plant === "" && box.station.id === 1) {
        let errors = this.state.errors.slice();
        let index = errors.indexOf("plant");
        if (index === -1) {
          errors.push("plant");
        }
        this.alertRef.current.sendAlert("All fields are required!");
        this.setState({ submitting: false, errors });
      } else if (box.has_grade && box.grade_index === -1) {
        let errors = this.state.errors.slice();
        let index = errors.indexOf("grade");
        if (index === -1) {
          errors.push("grade");
        }
        this.alertRef.current.sendAlert("All fields are required!");
        this.setState({ submitting: false, errors });
      } else {
        let cant = 1;
        if (multiple) {
          cant = this.state.numberBoxes;
        }
        if (cant < 1) {
          var errors = this.state.errors.slice();
          let index = errors.indexOf("repeat");
          if (index === -1) {
            errors.push("repeat");
          }
          this.alertRef.current.sendAlert("Repeat field is required!");
          this.setState({ submitting: false, errors });
        } else {
          let boxes = this.state.boxes.slice();
          let box = this.state.currentBox;
          for (let i = 0; i < cant; i++) {
            boxes.unshift({
              id: -1,
              item_id: box.item.id,
              item: box.item.name,
              item_average_invoice_price: box.item_average_invoice_price,
              category: box.item.category.category_name,
              brand: box.brand.brand_name,
              brand_id: box.brand.id,
              station: box.station.name,
              station_id: box.station.id,
              plant: box.plant,
              vendor_lot_number: box.vendor_lot_number,
              grade: box.grade ? box.grade.grade : undefined,
              grade_id: box.grade ? box.grade.id : -1,
              has_grade: box.item.has_grade,
              weight: box.weight,
              pieces: box.numberItems,
              price: box.price,
              packingDate: box.packingDate,
              measureUnit: box.measureUnit,
            });
          }
          this.setState({
            numberBoxes: 1,
            currentBox: {
              index: -1,
              station_index: -1,
              station: undefined,
              plant: "",
              vendor_lot_number: "",
              price: "",
              packingDate: "",
              brand_index: -1,
              brand: undefined,
              grade_index: -1,
              grade: undefined,
              category_index: -1,
              category: undefined,
              item_index: -1,
              item: undefined,
              selectedItem: null,
              item_average_invoice_price: 0,
              weight: "",
              numberItems: "",
              measureUnit: undefined,
              has_grade: false,
            },
            boxes,
          });
        }
      }
    } else {
      let index;
      let errors = this.state.errors.slice();
      if (box.station_index === -1) {
        index = errors.indexOf("station");
        if (index === -1) {
          errors.push("station");
        }
      }
      if (box.brand_index === -1) {
        index = errors.indexOf("brand");
        if (index === -1) {
          errors.push("brand");
        }
      }
      if (box.measureUnit && weightShouldBeLimited && box.weight > 99) {
        index = errors.indexOf("weight");
        if (index === -1) errors.push("weight");
      }
      if (box.weight <= 0) {
        index = errors.indexOf("weight");
        if (index === -1) errors.push("weight");
      }
      if (box.price === "" || box.price === undefined || box.price <= 0) {
        index = errors.indexOf("price");
        if (index === -1) {
          errors.push("price");
        }
      }
      if (box.plant === "") {
        index = errors.indexOf("plant");
        if (index === -1) {
          errors.push("plant");
        }
      }
      if (box.vendor_lot_number === "" || box.vendor_lot_number === undefined) {
        index = errors.indexOf("vendor_lot_number");
        if (index === -1) {
          errors.push("vendor_lot_number");
        }
      }
      if (box.item_index === -1) {
        index = errors.indexOf("item");
        if (index === -1) {
          errors.push("item");
        }
      }
      if (
        box.packingDate === undefined ||
        box.packingDate === "" ||
        moment().format("YYYY-MM-DD") < moment(box.packingDate).format("YYYY-MM-DD")
      ) {
        index = errors.indexOf("packingDate");
        if (index === -1) {
          errors.push("packingDate");
        }
      }
      if (box.item_index !== -1 && box.has_grade && box.grade_index === -1) {
        index = errors.indexOf("grade");
        if (index === -1) {
          errors.push("grade");
        }
      }
      if (box.numberItems === "" || box.numberItems <= 0) {
        index = errors.indexOf("numberItems");
        if (index === -1) {
          errors.push("numberItems");
        }
        this.alertRef.current.sendAlert("The number of pieces must be a positive integer.");
      } else if (this.state.errors_box.length > 0) {
        this.alertRef.current.sendAlert("Please, fix errors of previously added items.");
      } else {
        this.alertRef.current.sendAlert("All fields are required!");
      }
      this.setState({ submitting: false, errors });
    }
  };

  finishInvoiceWithPricesCheck = () => {
    let over_average_price = false;
    let boxes = this.state.boxes;
    let i = 0;
    while (i < boxes.length && !over_average_price) {
      let average_invoice_price_for_item = boxes[i].item_average_invoice_price;
      over_average_price =
        average_invoice_price_for_item > 0 &&
        Math.abs(boxes[i].price - average_invoice_price_for_item) > average_invoice_price_for_item * INVOICE_PRICE_DEVIATION;
      i++;
    }
    let errors = this.state.errors_box.slice();
    if (errors.length > 0) {
      this.alertRef.current.sendAlert("Please, fix errors of previously added items.");
    } else if (over_average_price) {
      this.setState({ over_average_price, openFinishInvoiceModal: true });
    } else {
      this.finishInvoice(false);
    }
  };

  confirmSubmit = () => {
    this.setState({ finishing: true, openFinishInvoiceModal: false }, () => {
      this.debounceFinish(true);
    });
  };

  finishInvoice = (withOverAveragePrice) => {
    this.setState({ submitting: true, finishing: true });
    var data = new FormData();
    data.append("invoice", this.props.invoiceDetail.invoice.id);
    for (let i = 0; i < this.state.boxes.length; i++) {
      let box = this.state.boxes[i];
      if (box.has_grade) {
        data.append(
          "boxes",
          JSON.stringify(
            Object.assign(
              {},
              {
                id: box.id !== -1 ? box.id : undefined,
                station: box.station_id,
                plant: box.plant, // <-------------------------------------------- plant
                vendor_lot_number: box.vendor_lot_number,
                item: box.item_id,
                brand: box.brand_id,
                weight: box.weight !== "" ? box.weight : undefined,
                number_items: box.pieces !== "" ? box.pieces : undefined,
                price: box.price !== "" ? box.price : undefined,
                grade: box.grade_id,
                packing_date: moment(box.packingDate).format("YYYY-MM-DD"),
              }
            )
          )
        );
      } else {
        data.append(
          "boxes",
          JSON.stringify(
            Object.assign(
              {},
              {
                id: box.id !== -1 ? box.id : undefined,
                station: box.station_id,
                plant: box.plant, // <-------------------------------------------- plant
                vendor_lot_number: box.vendor_lot_number,
                item: box.item_id,
                brand: box.brand_id,
                weight: box.weight !== "" ? box.weight : undefined,
                number_items: box.pieces !== "" ? box.pieces : undefined,
                price: box.price !== "" ? box.price : undefined,
                packing_date: moment(box.packingDate).format("YYYY-MM-DD"),
              }
            )
          )
        );
      }
    }

    if (withOverAveragePrice) {
      data.append("over_average_price", 1);
    } // If there is deviation 'sends True' to backeckend
    if (!data.get("boxes")) {
      this.setState({ submitting: false, finishing: false });
      this.alertRef.current.sendAlert("There is not items in the box!");
    } else {
      createInventories(data)
        .then((r) => {
          this.setState({ submitting: false, finishing: false, boxes: [] });
          this.alertRef.current.sendAlert("Items have been added to inventory", "success");
          this.props.history.push("/invoice/" + this.props.invoiceDetail.invoice.id + "/labels");
        })
        .catch((err) => {
          this.setState({ submitting: false, finishing: false, openFinishInvoiceModal: false });
          showErrors(err, this.alertRef);
        });
    }
  };

  deleteBox = (index) => {
    if (this.state.errors_box.length === 0) {
      let boxes = this.state.boxes.slice();
      boxes.splice(index, 1);
      this.setState({ boxes });
    } else {
      this.alertRef.current.sendAlert("Please, fix errors of previously added items.");
    }
  };

  arrayObjectIndexOf = (myArray, searchTerm, property) => {
    for (var i = 0, len = myArray.length; i < len; i++) {
      if (myArray[i][property] === searchTerm) return i;
    }
    return -1;
  };

  editBox = (index) => {
    let boxes = this.state.boxes.slice();
    let box = boxes[index];
    let currentBox = this.state.currentBox;
    currentBox.index = 0;
    currentBox.item = {
      id: box.item_id,
      name: box.item,
      category: { category_name: box.category },
      has_grade: box.has_grade,
    };
    currentBox.selectedItem = {
      value: box.item_id,
      label: box.item,
    };
    currentBox.item_index = box.item_id;
    currentBox.item_average_invoice_price = box.item_average_invoice_price;
    currentBox.has_grade = box.has_grade;

    currentBox.brand = {
      id: box.brand_id,
      brand_name: box.brand,
    };
    currentBox.brand_index = this.arrayObjectIndexOf(this.props.brandsList.brands.results, box.brand_id, "id");

    currentBox.station = {
      id: box.station_id,
      name: box.station,
    };
    currentBox.station_index = this.arrayObjectIndexOf(this.props.stationsList.stations.results, box.station_id, "id");

    if (box.grade !== undefined) {
      currentBox.grade = {
        id: box.grade_id,
        grade: box.grade,
      };
      currentBox.grade_index = this.arrayObjectIndexOf(this.props.gradesList.grades.results, box.grade_id, "id");
    }
    currentBox.plant = box.plant; // <-------------------------------------------- plant
    currentBox.vendor_lot_number = box.vendor_lot_number;
    currentBox.weight = box.weight;
    currentBox.numberItems = box.pieces;
    currentBox.price = box.price;
    currentBox.packingDate = box.packingDate;
    boxes.splice(index, 1);
    this.setState({ currentBox, boxes, errors: [] });
  };

  handleWeightBoxesChange = (event, index) => {
    let boxes = this.state.boxes.slice();
    boxes[index].weight = event.target.value;

    var errors_box = this.state.errors_box.slice();
    const err_string = "weight-Box-".concat(String(index));
    var index_error = errors_box.indexOf(err_string);
    if (boxes[index].weight < 0) {
      if (index_error === -1) {
        errors_box.push(err_string);
      }
    } else {
      if (index_error !== -1) {
        errors_box = this.spliceError_box(err_string);
        boxes[index].over_average_price = this.state.over_average_price
          ? Math.abs(boxes[index].price - boxes[index].average_invoice_price_for_item) >
            boxes[index].average_invoice_price_for_item * INVOICE_PRICE_DEVIATION
          : false;
      }
    }
    this.setState({ boxes, errors_box });
  };

  handlePiecesBoxesChange = (event, index) => {
    let boxes = this.state.boxes.slice();
    boxes[index].pieces = event.target.value;

    var errors_box = this.state.errors_box.slice();
    const err_string = "numberItems-Box-".concat(String(index));
    var index_error = errors_box.indexOf(err_string);
    if (boxes[index].pieces % 1 > 0 || boxes[index].pieces < 0) {
      if (index_error === -1) {
        errors_box.push(err_string);
      }
    } else {
      if (!(index_error === -1)) {
        errors_box = this.spliceError_box(err_string);
      }
    }
    this.setState({ boxes, errors_box });
  };

  handlePriceBoxesChange = (event, index) => {
    let boxes = this.state.boxes.slice();
    boxes[index].price = event.target.value;

    var errors_box = this.state.errors_box.slice();
    const err_string = "price-Box-".concat(String(index));
    var index_error = errors_box.indexOf(err_string);
    if (boxes[index].price < 0) {
      if (index_error === -1) {
        errors_box.push(err_string);
      }
    } else {
      if (index_error !== -1) {
        errors_box = this.spliceError_box(err_string);
        boxes[index].over_average_price = this.state.over_average_price
          ? Math.abs(boxes[index].price - boxes[index].average_invoice_price_for_item) >
            boxes[index].average_invoice_price_for_item * INVOICE_PRICE_DEVIATION
          : false;
      }
    }
    this.setState({ boxes, errors_box });
  };

  handleNumberBoxesChange = (event) => {
    var errors = this.spliceError("repeat");
    this.setState({ numberBoxes: parseInt(event.target.value, 10), errors });
  };

  goToLabels = () => {
    this.props.history.push("/invoice/" + this.props.invoiceDetail.invoice.id + "/labels");
  };

  weightShouldBeLimited = () => {
    return (
      this.state.currentBox.measureUnit !== undefined &&
      ["lb", "kg"].includes(this.state.currentBox.measureUnit) &&
      ![0, 2].includes(this.state.currentBox.station_index)
    );
  };

  render() {
    if (this.props.boxesList.loading || this.props.invoiceDetail.loading) {
      return (
        <div>
          <Alert ref={this.alertRef} />
          <Spinner />
        </div>
      );
    }

    if (
      this.props.invoiceDetail.invoice.id === Number(this.props.match.params.id) &&
      this.props.invoiceDetail.invoice.purchaseorder &&
      this.props.invoiceDetail.invoice.purchaseorder_status === 1
    ) {
      return <Navigate to={`/purchase_orders/${this.props.invoiceDetail.invoice.purchaseorder}/invoice`} />;
    }

    let over_average_price_message = `There are items whose price deviate the average in more than a 10%.
                                      Would you like to continue anyway?`;
    return (
      <div>
        <Alert ref={this.alertRef} />
        {this.state.finishing && <Spinner />}
        <InvoiceDetail
          invoice={this.props.invoiceDetail.invoice}
          finishInvoice={this.debounceFinishInvoiceWithPricesCheck}
          isAlreadyFinished={this.state.isAlreadyFinished}
          goToLabels={this.goToLabels}
        />
        <Modal
          closeModal={() => this.setState({ openFinishInvoiceModal: false })}
          isModalOpen={this.state.openFinishInvoiceModal}
          onConfirm={this.confirmSubmit}
          onCancel={() => this.setState({ openFinishInvoiceModal: false })}
          header="Warning!"
          content={over_average_price_message}
          onConfirmButtonText="Yes"
          onCancelButtonText="No"
        />
        {!this.state.hasBoxes && (
          <InputBox
            index={this.state.currentBox.index}
            plant={this.state.currentBox.plant} // <-------------------------------------------- plant
            vendor_lot_number={this.state.currentBox.vendor_lot_number}
            station={this.state.currentBox.station_index}
            price={this.state.currentBox.price}
            packingDate={this.state.currentBox.packingDate}
            brand={this.state.currentBox.brand_index}
            hasGrade={this.state.currentBox.has_grade}
            grade={this.state.currentBox.grade_index}
            type={this.state.currentBox.item_index}
            selectedItem={this.state.currentBox.selectedItem}
            weight={this.state.currentBox.weight}
            weightShouldBeLimited={this.weightShouldBeLimited}
            numberItems={this.state.currentBox.numberItems}
            stations={this.props.stationsList.stations.results}
            onStationChange={this.handleStationChange}
            onPriceChange={this.handlePriceChange}
            onDatePackingChange={this.handleDatePackingChange}
            brands={this.props.brandsList.brands.results}
            onBrandChange={this.handleBrandChange}
            grades={this.props.gradesList.grades.results}
            onGradeChange={this.handleGradeChange}
            items={this.props.itemsList.items.results}
            onItemChange={this.handleItemChange}
            onWeightChange={this.handleWeightChange}
            onNumberItemsChange={this.handleNumberItemsChange}
            onPlantChange={this.handlePlantChange} // <-------------------------------------------- plant
            onLotChange={this.handleLotChange}
            submitBox={this.submitBox}
            onNumberBoxesChange={this.handleNumberBoxesChange}
            numberBoxes={this.state.numberBoxes}
            measureUnit={this.state.currentBox.measureUnit}
            searchItems={this.searchItems}
            isLoadingItems={this.state.isLoadingItems}
            errors={this.state.errors}
          />
        )}
        <Boxes
          isAlreadyFinished={this.state.isAlreadyFinished}
          boxes={this.state.boxes}
          deleteBox={this.deleteBox}
          editBox={this.editBox}
          onWeightBoxesChange={this.handleWeightBoxesChange}
          onPiecesBoxesChange={this.handlePiecesBoxesChange}
          onPriceBoxesChange={this.handlePriceBoxesChange}
          showLines={true}
          overAveragePriceWarning={this.state.over_average_price}
          errors={this.state.errors_box}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    vendorsList: state.invoices.vendorsList,
    invoiceDetail: state.invoices.invoiceDetail,
    stationsList: state.sessions.stationsList,
    brandsList: state.inventories.brandsList,
    gradesList: state.inventories.gradesList,
    boxesList: state.invoices.boxesList,
    itemsList: state.inventories.itemsList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInvoice: (iId) => {
      dispatch(fetchInvoice(iId)).payload.then(
        (response) => {
          dispatch(fetchInvoiceSuccess(response.data));
        },
        (error) => {
          dispatch(fetchInvoiceFailure(error));
        }
      );
    },
    fetchStations: () => {
      dispatch(fetchStations()).payload.then(
        (response) => {
          dispatch(fetchStationsSuccess(response.data));
        },
        (error) => {
          dispatch(fetchStationsFailure(error));
        }
      );
    },
    fetchBrands: () => {
      dispatch(fetchBrands()).payload.then(
        (response) => {
          dispatch(fetchBrandsSuccess(response.data));
        },
        (error) => {
          dispatch(fetchBrandsFailure(error));
        }
      );
    },
    fetchGrades: () => {
      dispatch(fetchGrades()).payload.then(
        (response) => {
          dispatch(fetchGradesSuccess(response.data));
        },
        (error) => {
          dispatch(fetchGradesFailure(error));
        }
      );
    },
    fetchBoxes: (cId, dataBox) => {
      dispatch(fetchBoxes(cId, dataBox)).payload.then(
        (response) => {
          dispatch(fetchBoxesSuccess(response.data));
        },
        (error) => {
          dispatch(fetchBoxesFailure(error));
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InvoiceContainer));
